import { createFileRoute } from "@tanstack/react-router";
import HealthcareDetailPage from "@project/user/pages/care/healthcare.$id";
import medicalImg from "@project/assets/home-medical.webp";

export const Route = createFileRoute("/_user/_care/healthcare/$id")({
  head: () => ({
    meta: [
      { title: "Healthcare Detail — Jivandhara" },
      {
        name: "description",
        content:
          "Detailed medical services and facilities for the selected Jivandhara healthcare unit.",
      },
      { property: "og:title", content: "Healthcare Detail — Jivandhara" },
      { property: "og:image", content: medicalImg },
    ],
  }),
  component: HealthcareDetailPage,
});
